<template>
  <div class="machine">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="width_center_1200">
      <div class="machine-type">
        <el-tabs v-model="tabsData.current" @tab-click="handleTab">
          <el-tab-pane v-for="(item, index) in tabsData.list" :key="index" :label="item.name"></el-tab-pane>
        </el-tabs>
        <div class="filter-box">
          <!-- <el-dropdown trigger="click" @command="handleArea">
            <span class="el-dropdown-link">
              {{ areaData.label }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in areaData.list"
                :key="index"
                :command="index"
              >{{ item.title }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <el-dropdown trigger="click" @command="handleDistance">
            <span class="el-dropdown-link">
              {{ distanceData.label }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in distanceData.list"
                :key="index"
                :command="index"
              >{{ item.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div v-loading="loading" class="machine-list">
        <ul>
          <li v-for="(item, index) in list" :key="index" @click="handleDetail(item)">
            <el-image :src="item.vemimg" lazy></el-image>
            <div v-if="item.lables" class="labels">
              <div
                v-for="(v, k) in item.lables.split(',')"
                :key="k"
                class="item"
                :style="getColors()"
              >{{ v }}</div>
            </div>
            <div class="head">
              <div class="name">{{ item.vemName }}</div>
              <div class="location">
                <svg-icon iconClass="location" />
                {{ item.distance }}{{ item.distanceunit }}
              </div>
            </div>
            <div class="address-box">
              <div>
                <div class="address">{{ item.vemaddress }}</div>
                <div v-if="item.ptype === 2" class="address" style="padding-top: 4px;">{{ lang.machine_no }}: {{ item.vemId }}</div>
              </div>
              <!-- <div class="btn">{{ lang.location }}</div> -->
            </div>
          </li>
        </ul>
        <el-empty
          v-if="list.length === 0"
          :description="lang.no_data"
          style="padding-bottom: 100px"
        ></el-empty>
      </div>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { getvendingmachinelist } from '@/api/vendingmachine.js'
import { getarealist } from '@/api/home'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  data() {
    return {
      tabsData: {
        list: [
          {
            name: this.$t('machine').all,
            value: 0
          },
          {
            name: this.$t('machine').vending_machine,
            value: 1
          },
          {
            name: this.$t('machine').coffee_machine,
            value: 2
          }
        ],
        current: 0
      },
      loading: false,
      list: [],
      colors: ['#D10000', '#43D100'],
      distanceData: {
        show: false,
        label: this.$t('machine').default,
        list: [
          {
            value: -1,
            name: this.$t('machine').default
          },
          {
            value: 0,
            name: this.$t('machine').distance_text1
          },
          {
            value: 1,
            name: this.$t('machine').distance_text2
          }
        ]
      },
      search: {
        keyname: '',
        orderkey: -1, // 排序：-1 默认 ，0 由远到近 1由近到远
        areaid: 0,
        ptype: 0 // 0 全部 1 售货机 2迅猫啡
      },
      areaData: {
        label: this.$t('machine').area,
        show: false,
        list: []
      }
    }
  },
  computed: {
    lang() {
      return this.$t('machine')
    },
    ...mapGetters(['isLogin', 'location'])
  },
  watch: {
    location: {
      handler(val) {
        if (val) {
          if (this.$route.query.type) {
            this.search.ptype = Number(this.$route.query.type)
            this.tabsData.current = this.$route.query.type
          }
          this.getList()
          this.getAreaList()
        }
      },
      immediate: true
    }
  },
  methods: {
    handleDetail(item) {
      if (item.ptype === 1) {
        this.$router.push(`/machine/index?vemId=${item.vemId}`)
      }
      if (item.ptype === 2) {
        this.$router.push(`/coffee/index?vemId=${item.vemId}`)
      }
    },
    getColors() {
      let random = Math.round(Math.random() * 1)
      let color = `background: ${this.colors[random]}`
      return color
    },
    handleTab(e) {
      this.search.ptype = parseInt(e.index)
      this.getList()
    },
    getList() {
      this.loading = true
      getvendingmachinelist({
        ...this.location,
        ...this.search
      }).then(({ data }) => {
        this.loading = false
        this.list = data
      })
    },
    handleDistance(index) {
      this.distanceData.label = this.distanceData.list[index].name
      this.search.orderkey = this.distanceData.list[index].value
      this.getList()
    },
    handleArea(index) {
      this.areaData.label = this.areaData.list[index].title
      this.search.areaid = this.areaData.list[index].id
      this.getList()
    },
    async getAreaList() {
      const { data } = await getarealist()
      this.areaData.list = data[0].items
    }
  }
}
</script>
<style lang="scss" scoped>
.machine-type {
  position: relative;
  background: #fff;
  margin: 20px auto;
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  /deep/ .el-tabs__item.is-active {
    color: #ec9221;
  }
  /deep/ .el-tabs__active-bar {
    color: #ec9221;
  }
  /deep/ .el-tabs__item:hover {
    color: #ec9221;
  }
  /deep/ .el-tabs__item {
    height: 52px;
    line-height: 52px;
    color: #aaaaaa;
    font-size: 14px;
  }
  /deep/ .el-tabs__active-bar {
    bottom: 10px;
  }
  .filter-box {
    position: absolute;
    top: 0;
    right: 15px;
    height: 52px;
    line-height: 52px;
    .el-dropdown {
      color: #000000;
      margin-left: 20px;
      font-size: 14px;
      &:last-child {
        color: #ec9221;
      }
    }
  }
}
.machine-list {
  width: 1200px;
  overflow: hidden;
  ul {
    width: 110%;
  }
  li {
    cursor: pointer;
    float: left;
    width: 340px;
    height: 310px;
    background: #fff;
    margin: 0 30px 20px 0;
    padding: 10px 20px;
    .el-image {
      display: flex;
      width: 345px;
      height: 193px;
      border-radius: 8px;
      margin-bottom: 10px;
    }
    .labels {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .item {
        height: 24px;
        line-height: 24px;
        background: #d10000;
        padding: 0 10px;
        color: #fff;
        font-size: 12px;
        margin-right: 10px;
        &.green {
          background: #43d100;
        }
      }
    }
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .name {
        font-size: 14px;
        color: #4f4f4f;
      }
      .location {
        font-size: 12px;
        color: #aaaaaa;
      }
    }
    .address-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      .address {
        color: #aaaaaa;
      }
      .btn {
        color: #0061b5;
      }
    }
  }
}
</style>